



















































import { defineComponent, onBeforeUnmount, onMounted, ref } from '@nuxtjs/composition-api'
import { PropType } from 'vue';
import { OptionToSelect } from '~/utils/types/ProductPage';
import { ProductForProductPageType } from '~/utils/types/solepro/Product';
import PurchaseOptionCard from './PurchaseOptionCard.vue';
import { Pagination, Navigation } from 'swiper'
import { SwiperCore, Swiper, SwiperSlide } from 'swiper-vue2'
import { getIsBook } from '~/utils/solepro/products';
import PaymentMethodsIcons from '../PaymentMethodsIcons.vue';
import { setElementWidthByCardsContainer } from '~/utils/helpers/functions';


SwiperCore.use([Pagination, Navigation])
export default defineComponent({
    props: {
        optionBlock: {
            type: Object as PropType<OptionToSelect>,
            required: true
        },
        product: {
            type: Object as PropType<ProductForProductPageType>,
            required: true
        },
        optionIndex: {
            type: Number,
            default: 0
        }
    },
    components: {
        PurchaseOptionCard,
        Swiper,
        SwiperSlide,
        PaymentMethodsIcons
    },
    setup(props) {
        const { product } = props;
        const useCarousel = ref(false);
        const swiperProps = {
            modules: [Navigation, Pagination],
            slideClass: "slide",
            navigation: {
                prevEl: '.section-purchase-options .navigation-prev',
                nextEl: '.section-purchase-options .navigation-next',
            },
            slidesPerView: 3,
            slidesPerGroup: 3,
            direction: "horizontal",
            spaceBetween: 20,
        }

        const handleResize = () => {
            useCarousel.value = props.optionBlock.options.length > 3 && window.innerWidth >= 1024
        }
        const cardsQty = ref(0)
        
        onBeforeUnmount(() => {
            window.removeEventListener('resize', handleResize)
        })

        return {
            useCarousel,
            swiperProps,
            isBook: getIsBook(props.product),
            cardsQty,
            handleResize
        }
    },
    mounted() {
        this.useCarousel = this.optionBlock.options.length > 3 && window.innerWidth >= 1024
        window.addEventListener('resize', this.handleResize);
        this.cardsQty = Array.from(document.querySelectorAll('[data-component="productPurchaseOptions"]')).length
        const hRow = this.$el.querySelector('.row-heading') as HTMLElement;
        setElementWidthByCardsContainer(hRow)
    },
    methods:{
        calculateHeights(swiper) {
            const slides = swiper.$el[0].querySelectorAll('.slide');
            const tallest =Array.from(slides).reduce((tallest: Element, slide: Element) => {
                return slide.querySelector('.solepro-option-card').getBoundingClientRect().height > tallest.querySelector('.solepro-option-card').getBoundingClientRect().height ? slide : tallest;
            });
            const h = (tallest as HTMLElement).offsetHeight+'px';
            slides.forEach(el => el.querySelector('.solepro-option-card').style.height = h)
        },
        afterInit(swiper) {
            const interval = setInterval(()=>{
                const slides = swiper.$el[0].querySelectorAll('.slide');
                if(slides.length>1){
                    clearInterval(interval);
                    swiper.update();
                    console.log('updated');
                   this.calculateHeights(swiper)
                }
            },100)
            setTimeout(() => {
                clearInterval(interval)
            }, 5000)
        },
    }
})
